import { Component, OnInit, Input } from '@angular/core';
import { NJDocData, NJDocDefTemplate, NJReadDocDefTemplateLookup } from '../DOData'
import { DocDefPrimLibService } from '../../doc-def-prim-lib.service';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'cy-dolabel',
    templateUrl: './dolabel.component.html',
    styleUrls: ['./dolabel.component.css']
})

export class DOLabelComponent implements OnInit  {

    constructor(private data: DocDefPrimLibService) {
    }
    @Input() DocDefTemplate: NJDocDefTemplate;
    @Input() customParameters: any;
    @Input() DocData: NJDocData;
    lblDocDefTemplate: NJDocDefTemplate;
    @Input() showIcon: boolean= false;
    @Input() labelIcon: IconDefinition = null;
    @Input() isValid: boolean;
    Styles: any;
    Class: any;
    txtDocData: NJDocData;
    LabelStyle: any;

    // Public Properties
    public isHidden: boolean = true;
    public isRequiredValidation: boolean = false;
    //public isNavigation: boolean = false;
    //public _id: string = 'ID' + this.DocDefTemplate.docDefTemplateID;

    //get id(): string {
    //    if (this.customParameters.Navigation != null) {
    //        return this.customParameters.Navigation;
    //    }
    //    else {
    //        return 'ID' + this.DocDefTemplate.docDefTemplateID;
    //    }
    //}
    //set id(Id: string) {
    //    this._id = Id;
    //}

    get txtValue(): string {
        if (this.customParameters.ValueToBlank != null) {
            if (this.txtDocData != undefined && this.txtDocData != null) {
                if (this.txtDocData.dataValue == this.customParameters.ValueToBlank)
                    this.txtDocData.dataValue = "";
            }
        }
        if (this.txtDocData != undefined && this.txtDocData != null) {
            return this.txtDocData.dataValue;
        }
        else return "";
    }
    set txtValue(TxtValue: string) {
        this.txtDocData.dataValue = TxtValue;
    }
    //set txtValue(TxtValue: string) {
    //    if (!this.isLoading) {
    //        if (this.txtDocData.dataValue != TxtValue) {
    //            this.txtDocData.dataValue = TxtValue;
    //            if (this.customParameters.isPhone != null) {
    //                TxtValue = this.fmtPhone(TxtValue);
    //                this.txtDocData.dataValue = TxtValue;
    //            }
    //            if (this.customParameters.isSSN != null) {
    //                TxtValue = this.fmtSSN(TxtValue);
    //                this.txtDocData.dataValue = TxtValue;
    //            }
    //            if (this.customParameters.isNumeric != null) {
    //                TxtValue = this.NumericOnly(TxtValue);
    //                this.txtDocData.dataValue = TxtValue;
    //            }
    //            this.isDirty = true;
    //        }
    //    }
    //}

    ngOnInit() {
        this.lblDocDefTemplate = this.DocDefTemplate;
        if (this.DocData != undefined && this.DocData != null) {
            this.txtDocData = this.DocData;
            this.txtValue = this.txtDocData.dataValue;
        }
        this.setHiddenStatus();
        this.setRequiredValidation();
        //this.setNavigationStatus();
    }
    ngOnChanges(): void {
        this.lblDocDefTemplate = this.DocDefTemplate;
        if (this.DocData != undefined && this.DocData != null) {
            this.txtDocData = this.DocData;
            this.txtValue = this.txtDocData.dataValue;
        }
        else
            if (this.lblDocDefTemplate.tLabel.length == 0) {
                this.lblDocDefTemplate.tLabel = "|"
            }
        if (this.customParameters['LabelBlank'] == "Yes") {
            this.lblDocDefTemplate.tLabel = ""
        }
        if (this.customParameters['Styles'] != null) {
            let styles = this.data.replaceAll(this.customParameters['Styles'], "'", '"');
            this.Styles = JSON.parse(styles);
        }
        if (this.customParameters['Class'] != null) {
            this.Class = this.data.replaceAll(this.customParameters['Class'], "'", '"');
        } else {
            this.Class = "";
        }

    }

    //setNavigationStatus() {
    //    if (this.customParameters.Navigation != null) {
    //        this._id = this.customParameters.Navigation;
    //        this.isNavigation = true;
    //    }
    //    else {
    //        this.isNavigation = false;
    //        this._id = 'ID' + this.DocDefTemplate.docDefTemplateID;
    //    }
    //}

    //public getId() {
    //    if (this.isNavigation)
    //        return this.customParameters.Navigation;
    //    else
    //        return 'ID' + this.DocDefTemplate.docDefTemplateID;
    //}

    setHiddenStatus() {
        if (this.customParameters.Hidden == 'Yes')
            this.isHidden = true;
        //is the the required seccode in the user's credentials
        else if (this.customParameters["HiddenIfMissingSecCode"]) {
            //this.data.checkIfCodeInUserSecurity(this.customParameters["HiddenIfMissingSecCode"]).subscribe((ret: boolean) => {
            //    if (ret) {
            //        this.isHidden = false;
            //    }
            //    else {
            //        this.isHidden = true;
            //    }
            //        });
        }
        else this.isHidden = false;
    }

    setRequiredValidation() {
        if (this.customParameters.isRequiredValidation)
            this.isRequiredValidation = true;
        else
            this.isRequiredValidation = false;
    }

    getLabelStyle(): object {
        if (this.customParameters['LabelStyle'] != null) {
            let styles = this.data.replaceAll(this.customParameters['LabelStyle'], "'", '"');
            this.LabelStyle = JSON.parse(styles);
            if (this.isValid) {
                return this.LabelStyle;
            }
            else {
                this.LabelStyle['background-color'] = "lightpink";
                return this.LabelStyle;
            }
        }
        else {
            if (this.isValid)
                return null
            else
                return { "background-color": "lightpink" };
        }
    }
}
